export default __webpack_public_path__ + "static/media/long_left_arrow_white.8837dca9.svg";